import {AccountInfoState} from "@/app/(pages)/account/accountSlice";
import $http from "@/app/_api";
import {UserGlobalInfo} from "@/Core/Login/types/user";

export async function getAccountInfoData(user: UserGlobalInfo) {
    const {vipExp} = user.baseInfo

    const mergeData:AccountInfoState['info'] = {
        userVipExp: 0,
        userNextVipExp: 0,
        userVipName: '',
        vipConfigList: {
            vipLevels: [],
            vipBenefits: []
        }
    }

    const response = await $http.Account.vipConfigList();
    const { vipLevels } = response;

    // 根据用户当前vip等级获取用户vip等级名称
    const userVipLevel = vipLevels.find((item: any) => item.vipLevel === user.baseInfo.vipLevel);
    mergeData.userVipName = userVipLevel?.levelName || "";

    // 根据用户当前vip等级获取用户下一个vip等级所需经验
    const userNextVipLevel = vipLevels.find((item: any) => item.vipLevel === user.baseInfo.vipLevel + 1);
    mergeData.userNextVipExp = userNextVipLevel?.reqExperience || 0;

    // 用户当前vip经验
    mergeData.userVipExp = vipExp;

    // 客户端vip等级配置列表
    mergeData.vipConfigList = response;

    return mergeData;
}